
import { mapActions } from 'vuex'
import { SignatureHelper } from '@/helpers/SignatureHelper'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { SignatureCacheMixin } from './SignatureCacheMixin'

export const SignatureAddMixin = {
  mixins: [SignatureCacheMixin],
  data () {
    return {
      signedText: '',
      validator: SignatureHelper.getSignatureValidator()
    }
  },
  computed: {
    clientFullName () {
      console.log('!!!OVERRIDE COMPUTED - clientFullName!!!')
    },
    signatureAddModel () {
      return {
        signedName: this.clientFullName,
        signedText: this.signedText
      }
    }
  },
  watch: {
    signedText () {
      this.validator.validate(this.signatureAddModel)
    }
  },
  methods: {
    ...mapActions('RegistrationSignature', [
      'addSignature'
    ]),
    tryAddSignature () {
      const self = this
      self.validator.validate(self.signatureAddModel)
      if (!self.validator.isValid || !!self.loadingSignature) {
        return
      }
      self.error = ''
      return self.addSignature({ inviteId: self.inviteId, payload: self.signatureAddModel })
        .then(response => { self.afterAddSignature(response.data) })
        .catch(error => {
          if (ErrorHelper.isNotFound(error)) {
            self.afterAddSignature()
          } else {
            self.error = ErrorHelper.getError(error)
          }
        })
    },
    afterAddSignature () {
      // override if necessary
    }
  }
}
